import { render, staticRenderFns } from "./Emails.vue?vue&type=template&id=f458a426&scoped=true&"
import script from "./Emails.vue?vue&type=script&lang=js&"
export * from "./Emails.vue?vue&type=script&lang=js&"
import style0 from "./Emails.vue?vue&type=style&index=0&id=f458a426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f458a426",
  null
  
)

export default component.exports